import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateScheduleLoyaltyDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleLoyaltyDiscount/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllScheduleLoyaltyDiscounts extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleLoyaltyDiscount/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteAScheduleLoyaltyDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleLoyaltyDiscount/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetASingleScheduleLoyaltyDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleLoyaltyDiscount/GetById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateASingleScheduleLoyaltyDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleLoyaltyDiscount/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllLoyaltyDiscountsLight extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleLoyaltyDiscount/GetListLight");
  }
}

class UpdateUserScheduleLoyaltyDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleLoyaltyDiscount/UpdateUserStatus");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateScheduleLoyaltyDiscount,
  GetAllScheduleLoyaltyDiscounts,
  DeleteAScheduleLoyaltyDiscount,
  GetASingleScheduleLoyaltyDiscount,
  UpdateASingleScheduleLoyaltyDiscount,
  GetAllLoyaltyDiscountsLight,
  UpdateUserScheduleLoyaltyDiscount,
};
